import React from 'react';
import styled from 'styled-components';
import Box from '../atoms/Box';
import Text from '../atoms/Text';

// Style extrait de CourseDetails.jsx (bloc "Simplifiez vos prochains
// paiements") pour être réutilisé par tout encart de la même famille —
// icône + titre sur une ligne, description, puis un slot libre pour l'action
// (bouton, badges de store...). `tint` distingue deux encarts adjacents
// (ex. paiement + app) sans les confondre visuellement.
const TINTS = {
  blue: {
    background: 'linear-gradient(135deg, #eaf1ff 0%, #f0f7ff 100%)',
    border: '#d0e1ff',
  },
  green: {
    background: 'linear-gradient(135deg, #f3ffdf 0%, #f9ffee 100%)',
    border: '#dff0af',
  },
};

const Banner = styled(Box)`
  background: ${(p) => (TINTS[p.$tint] || TINTS.blue).background};
  border: 1px solid ${(p) => (TINTS[p.$tint] || TINTS.blue).border};
  border-radius: 12px;
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;

const Icon = styled.span`
  font-size: 1.5rem;
  line-height: 1;
  flex-shrink: 0;
`;

const Title = styled(Text)`
  font-family: 'LTSaeada', Arial, sans-serif;
  font-weight: 600;
  color: #2e414b;
  font-size: 1.1rem;
`;

const Description = styled(Text)`
  font-family: 'LTSaeada', Arial, sans-serif;
  font-weight: 400;
  color: #5a5a5a;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 16px;
`;

export default function PromoBanner({
  icon,
  title,
  description,
  tint = 'blue',
  children,
  ...props
}) {
  return (
    <Banner $tint={tint} {...props}>
      <Header>
        <Icon aria-hidden="true">{icon}</Icon>
        <Title>{title}</Title>
      </Header>
      <Description>{description}</Description>
      {children}
    </Banner>
  );
}
